import { Button } from '@apps/web/components/ui/button';

// One line: the window in effect, then the action that widens or narrows
// it, so the footer takes a single row at the end of the list.
function RecencyFooterLine({
    message,
    action,
    onAction,
}: {
    readonly message: string;
    readonly action: string;
    readonly onAction: () => void;
}) {
    return (
        <p className="text-muted-foreground px-2 py-3 text-center text-xs">
            {message}
            <span aria-hidden="true"> · </span>
            <Button
                className="h-auto p-0 text-xs font-normal"
                onClick={onAction}
                size="sm"
                type="button"
                variant="link"
            >
                {action}
            </Button>
        </p>
    );
}

export function ConversationsInboxRecencyFooter({
    isReachingEnd,
    onShowOlder,
    onShowRecentOnly,
    recentWindowDays,
}: {
    readonly isReachingEnd: boolean;
    readonly onShowOlder: () => void;
    readonly onShowRecentOnly: () => void;
    readonly recentWindowDays: number | null;
}) {
    if (recentWindowDays !== null) {
        return (
            <RecencyFooterLine
                action="Show older conversations"
                message={`Showing the last ${recentWindowDays} days`}
                onAction={onShowOlder}
            />
        );
    }
    return (
        <RecencyFooterLine
            action="Show recent only"
            message={
                isReachingEnd
                    ? 'Showing all conversations'
                    : 'Showing loaded conversations'
            }
            onAction={onShowRecentOnly}
        />
    );
}
